var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"show-txt",class:{'show-txt-rest':_vm.readonly}},[_c('span',{staticClass:"only-value"},[_c('span',[_vm._v(_vm._s(_vm.currentValue))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }